import { clearExchangeEvaluationCache } from "./detect/util.js";
import { clearTacticsCaches } from "./detect/tactics/index.js";
export function clearAllCaches() {
    clearExchangeEvaluationCache();
    clearTacticsCaches();
}
export function getCacheInfo() {
    return {
        message: "All caches are now capped at 5000 entries and auto-clear when exceeded. " +
            "Call clearAllCaches() between jobs for proactive cleanup.",
    };
}
//# sourceMappingURL=cacheUtils.js.map